import { State } from "@/store/modules/delayCodes/state";
import { defineMutations } from "direct-vuex";
import json from "@/assets/data.json";
import {
  filterData,
  INDEX_CODE,
  INDEX_PROCESS,
  INDEX_REASON,
  INDEX_STAKEHOLDER,
  ListToBeDisplayed
} from "./utils";

export enum MutationsTypes {
  SET_GROUPING_ID = "setGroupingId",
  SET_PROCESS_ID = "setProcessId",
  SET_REASON_ID = "setReasonId",
  SET_STAKEHOLDER_ID = "setStakeholderId",
  SET_SELECTED_LIST = "setSelectedList",
  RESET_SELECTION = "resetSelection",
  EXPERT_SET_CODE = "expertSetCode",
  SET_SEARCHED_TEXT = "setSearchedText",
  TOGGLE_OPEN_GROUP = "toggleOpenGroup"
}

function updateFilters(state: State) {
  if (state.rawData === null) {
    state.rawData = json;
    const { groupings, processes, reasons, stakeholders } = filterData(
      state.rawData,
      null,
      null,
      null,
      null
    );
    state.allGroupings = groupings;
    state.allProcesses = processes;
    state.allReasons = reasons;
    state.allStakeholders = stakeholders;
  }
  // eslint-disable-next-line prefer-const
  let { groupings, processes, reasons, stakeholders } = filterData(
    state.rawData,
    state.selectedGroupingId,
    state.selectedProcessId,
    state.selectedReasonId,
    state.selectedStakeholderId
  );

  switch (state.selectedListToDisplay) {
    case ListToBeDisplayed.Process:
      Object.keys(processes).forEach(keyProcess => {
        if (
          !processes[keyProcess]
            .toLowerCase()
            .includes(state.searchedText.toLowerCase())
        ) {
          delete processes[keyProcess];
        }
      });
      break;
    case ListToBeDisplayed.Reason:
      Object.keys(reasons).forEach(keyReasons => {
        if (
          !reasons[keyReasons]
            .toLowerCase()
            .includes(state.searchedText.toLowerCase())
        ) {
          delete reasons[keyReasons];
        }
      });
      break;
    case ListToBeDisplayed.Stakeholder:
      Object.keys(stakeholders).forEach(keyStakeholders => {
        if (
          !stakeholders[keyStakeholders]
            .toLowerCase()
            .includes(state.searchedText.toLowerCase())
        ) {
          delete stakeholders[keyStakeholders];
        }
      });
      break;
    default:
      break;
  }
  state.groupings = groupings;
  state.processes = processes;
  state.reasons = reasons;
  state.stakeholders = stakeholders;
}

export const mutations = defineMutations<State>()({
  [MutationsTypes.SET_GROUPING_ID](state, payload: number | null) {
    state.selectedGroupingId = payload;
    updateFilters(state);
    if (
      Object.keys(state.processes).length === 0 ||
      Object.keys(state.reasons).length === 0 ||
      Object.keys(state.stakeholders).length == 0
    ) {
      state.selectedProcessId = null;
      state.selectedReasonId = null;
      state.selectedStakeholderId = null;
      updateFilters(state);
    }
  },
  [MutationsTypes.SET_PROCESS_ID](state, payload: number | null) {
    state.selectedProcessId = payload;
    updateFilters(state);
    if (
      Object.keys(state.reasons).length === 0 ||
      Object.keys(state.stakeholders).length == 0 ||
      Object.keys(state.groupings).length == 0
    ) {
      state.selectedReasonId = null;
      state.selectedStakeholderId = null;
      state.selectedGroupingId = null;
      updateFilters(state);
    }
    if (payload !== null) {
      state.searchedText = "";
      state.selectedListToDisplay = ListToBeDisplayed.Reason;
    }
  },
  [MutationsTypes.SET_REASON_ID](state, payload: number | null) {
    state.selectedReasonId = payload;
    updateFilters(state);
    if (
      Object.keys(state.processes).length === 0 ||
      Object.keys(state.stakeholders).length == 0 ||
      Object.keys(state.groupings).length == 0
    ) {
      state.selectedProcessId = null;
      state.selectedStakeholderId = null;
      state.selectedGroupingId = null;
      updateFilters(state);
    }
    if (payload !== null) {
      state.searchedText = "";
      state.selectedListToDisplay = ListToBeDisplayed.Stakeholder;
    }
  },
  [MutationsTypes.SET_STAKEHOLDER_ID](state, payload: number | null) {
    state.selectedStakeholderId = payload;
    updateFilters(state);
    if (
      Object.keys(state.processes).length === 0 ||
      Object.keys(state.reasons).length === 0 ||
      Object.keys(state.groupings).length == 0
    ) {
      state.selectedProcessId = null;
      state.selectedReasonId = null;
      state.selectedGroupingId = null;
      updateFilters(state);
    }
  },
  [MutationsTypes.SET_SELECTED_LIST](state, payload: number) {
    state.searchedText = "";
    state.selectedListToDisplay = payload;
    updateFilters(state);
  },
  [MutationsTypes.RESET_SELECTION](state) {
    state.selectedGroupingId = null;
    state.selectedProcessId = null;
    state.selectedReasonId = null;
    state.selectedStakeholderId = null;
    state.searchedText = "";
    state.selectedListToDisplay = ListToBeDisplayed.None;
    state.expertModeCodeIsInvalid = false;
    state.expertModeCode = "";
    updateFilters(state);
  },
  [MutationsTypes.EXPERT_SET_CODE](state, payload: string) {
    state.expertModeCode = payload;
    state.expertModeCodeIsInvalid = false;
    if (state.expertModeCode.length === 3) {
      let found = false;
      state.rawData?.data.forEach(item => {
        if (
          (item[INDEX_CODE] as string).toUpperCase() === payload.toUpperCase()
        ) {
          found = true;
          state.selectedProcessId = item[INDEX_PROCESS] as number;
          state.selectedReasonId = item[INDEX_REASON] as number;
          state.selectedStakeholderId = item[INDEX_STAKEHOLDER] as number;
        }
      });
      state.expertModeCodeIsInvalid = !found;
    }
  },
  [MutationsTypes.SET_SEARCHED_TEXT](state, payload: string) {
    if (state.searchedText !== payload) {
      state.searchedText = payload;
      updateFilters(state);
    }
  },
  [MutationsTypes.TOGGLE_OPEN_GROUP](state, payload: number | null) {
    if (payload !== null) {
      const itemFound = state.openedStakeholderGroups.findIndex(item => {
        return item === payload;
      });
      if (itemFound === -1) {
        state.openedStakeholderGroups.push(payload);
      } else {
        state.openedStakeholderGroups.splice(itemFound, 1);
      }
    }
  }
});
